export const flowsconfig = {

  workflow: {
    service:{
      name:'workflow',
      title:'Workflows',
      key:'rid',
      num:true,
      fields:['rid','rix','nam','shc','mdc','dsc','vno','dcd','exi','sts','ast','stp'],
      params:{nam:'Name',shc:'Code',mdc:'Module',sts:'Status'},
      grid:[['nam','Name'],['shc','Code'],['mdc','Module'],['vno','Version'],['sts','Status'],['stp','Stamp']],
      bar:{pag:true,btn:['add','edit','del','view']},
      menu:{mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'},{t:'Module',v:'mdc'}],def:'nam'},
      eform:[
        {id:'nam',label:'Name',type:'tf',req:1,ops:{}},
        {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
        {id:'mdc',label:'Module Code',type:'tf',req:1,ops:{}},
        {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
        {id:'vno',label:'Version',type:'nf',req:1,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  workflowstate: {
    service:{
      name:'workflowstate',
      title:'Workflow States',
      key:'rid',
      num:true,
      fields:['rid','rix','nam','shc','wfi','wfn','wfc','sqn','isi','isf','dcd','exi','sts','ast','stp'],
      params:{nam:'State',shc:'Code',wfn:'Workflow',sts:'Status'},
      grid:[['wfn','Workflow'],['nam','State'],['shc','Code'],['sqn','Seq'],['isi','Initial'],['isf','Final'],['sts','Status']],
      bar:{pag:true,btn:['add','edit','del','view']},
      menu:{mnu:[{t:'Workflow',v:'wfn'},{t:'State',v:'nam'},{t:'Code',v:'shc'}],def:'nam'},
      eform:[
        {id:'wfi',label:'Workflow',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'workflow'}},
        {id:'nam',label:'State Name',type:'tf',req:1,ops:{}},
        {id:'shc',label:'State Code',type:'tf',req:1,ops:{}},
        {id:'sqn',label:'Sequence No.',type:'nf',req:1,ops:{}},
        {id:'isi',label:'Initial State',type:'nf',req:1,ops:{}},
        {id:'isf',label:'Final State',type:'nf',req:1,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  workflowtransition: {
    service:{
      name:'workflowtransition',
      title:'Workflow Transitions',
      key:'rid',
      num:true,
      fields:['rid','rix','wfi','wfn','wfc','fsi','fsn','fsc','wai','wan','wac','tsi','tsn','tsc','dsc','dcd','exi','sts','ast','stp'],
      params:{wfn:'Workflow',fsn:'From State',wan:'Action',tsn:'To State',sts:'Status'},
      grid:[['wfn','Workflow'],['fsn','From State'],['wan','Action'],['tsn','To State'],['dsc','Description'],['sts','Status']],
      bar:{pag:true,btn:['add','edit','del','view']},
      menu:{mnu:[{t:'Workflow',v:'wfn'},{t:'From',v:'fsn'},{t:'Action',v:'wan'},{t:'To',v:'tsn'}],def:'wfn'},
      eform:[
        {id:'wfi',label:'Workflow',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'workflow'}},
        {id:'fsi',label:'From State',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'workflowstate'}},
        {id:'wai',label:'Action',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'workflowaction'}},
        {id:'tsi',label:'To State',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'workflowstate'}},
        {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  workflowruntime: {
    service:{
      name:'workflowruntime',
      title:'Workflow Runtime',
      key:'rid',
      num:true,
      fields:['rid','rix','wfi','wfn','wfc','tbl','eix','currentstateid','wsi','wsn','wsc','sui','sun','sue','std','cpd','dcd','exi','sts','ast','stp'],
      params:{wfn:'Workflow',tbl:'Entity Table',wsn:'Current State',sun:'Started By',sts:'Status'},
      grid:[['wfn','Workflow'],['tbl','Entity Table'],['eix','Entity ID'],['wsn','Current State'],['sun','Starter'],['std','Started'],['cpd','Completed'],['sts','Status']],
      bar:{pag:true,btn:['add','edit','del','view']},
      menu:{mnu:[{t:'Workflow',v:'wfn'},{t:'Entity',v:'tbl'},{t:'State',v:'wsn'}],def:'wfn'},
      eform:[
        {id:'wfi',label:'Workflow',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'workflow'}},
        {id:'tbl',label:'Entity Table',type:'tf',req:1,ops:{}},
        {id:'eix',label:'Entity UUID',type:'tf',req:1,ops:{}},
        {id:'wsi',label:'Current State',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'workflowstate'}},
        {id:'sui',label:'Starter User',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'user'}},
        {id:'std',label:'Started',type:'df',req:0,ops:{}},
        {id:'cpd',label:'Completed',type:'nf',req:1,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  workflowtask: {
    service:{
      name:'workflowtask',
      title:'Workflow Tasks',
      key:'rid',
      num:true,
      fields:['rid','rix','wri','wfi','wfc','asu','asx','ttl','dsc','wsi','wsn','wsc','ddt','wpi','wpn','wpc','cpd','cpt','dcd','exi','sts','ast','stp'],
      params:{ttl:'Task',wfc:'Workflow',wsn:'State',wpn:'Priority',sts:'Status'},
      grid:[['ttl','Task'],['wfc','Workflow'],['wsn','State'],['wpn','Priority'],['ddt','Due Date'],['cpd','Completed'],['sts','Status']],
      bar:{pag:true,btn:['add','edit','del','view']},
      menu:{mnu:[{t:'Task',v:'ttl'},{t:'Workflow',v:'wfc'},{t:'State',v:'wsn'}],def:'ttl'},
      eform:[
        {id:'wri',label:'Runtime',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'workflowruntime'}},
        {id:'asx',label:'Assigned Staff',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'staff'}},
        {id:'asu',label:'Assigned Staff User',type:'tf',req:0,ops:{}},
        {id:'ttl',label:'Task Title',type:'tf',req:1,ops:{}},
        {id:'dsc',label:'Task Description',type:'ta',req:0,ops:{}},
        {id:'wsi',label:'Task State',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'workflowstate'}},
        {id:'ddt',label:'Due Date',type:'df',req:0,ops:{}},
        {id:'wpi',label:'Priority',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'workflowpriority'}},
        {id:'cpd',label:'Completed',type:'nf',req:1,ops:{}},
        {id:'cpt',label:'Completed Time',type:'df',req:0,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  workflowhistory: {
    service:{
      name:'workflowhistory',
      title:'Workflow History',
      key:'rid',
      num:true,
      fields:['rid','rix','wri','wrx','tbl','eix','wfi','wfx','wfc','wfn','mdc','fsi','fsc','fsn','tsi','tsc','tsn','wai','wac','wan','usx','unm','sfx','sfc','sfn','rmk','dcd','exi','sts','ast','stp'],
      params:{wfn:'Workflow',wan:'Action',unm:'User',sfn:'Staff',sts:'Status'},
      grid:[['wfn','Workflow'],['fsn','From'],['wan','Action'],['tsn','To'],['unm','User'],['sfn','Staff'],['rmk','Remarks'],['dcd','Created']],
      bar:{pag:true,btn:['add','edit','del','view']},
      menu:{mnu:[{t:'Workflow',v:'wfn'},{t:'Action',v:'wan'},{t:'User',v:'unm'}],def:'wfn'},
      eform:[
        {id:'wri',label:'Runtime',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'workflowruntime'}},
        {id:'fsi',label:'From State',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'workflowstate'}},
        {id:'tsi',label:'To State',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'workflowstate'}},
        {id:'wai',label:'Action',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'workflowaction'}},
        {id:'usx',label:'Actor User UUID',type:'tf',req:0,ops:{}},
        {id:'sfx',label:'Actor Staff',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'staff'}},
        {id:'rmk',label:'Remarks',type:'ta',req:0,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}},
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  }

};